import React from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import COLORS from '../../util/constants/colors';
import Typography from '../../components/Typography';
import { TrendUp } from '@phosphor-icons/react';
import { formatDateSlash } from '../../global/validation';
import { Skeleton } from 'antd';

const ReferralTrends = ({ referralTrends, loading }) => {
  const referralTrendsData = referralTrends?.map((trend) => ({
    name: formatDateSlash(trend.date),
    total_referrals: trend.total_referrals,
  }));

  return (
    <div className="referral-trends-section">
      <Typography variant="text" size="medium" bold className="referral-trends-header">
        <TrendUp color={COLORS.BLUE_PRIMARY_LITE} size={16} weight="bold" />
        &nbsp;
        Referral Trends
      </Typography>
      {loading ? (
        <Skeleton active />
      ) : (
        <ResponsiveContainer
          width="100%"
          height={300}
          minWidth="100%"
          style={{ marginTop: 16, marginRight: 16 }}
        >
          <LineChart data={referralTrendsData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" padding={{ left: 40, right: 40 }}/>
            <YAxis />
            <Tooltip />
            <Legend />
            <Line 
              type="monotone"
              dataKey="total_referrals"
              stroke={COLORS.BLUE_PRIMARY_LITE}
              dot={false}
              activeDot={{ r: 8 }}
              strokeWidth={2}
            />
            </LineChart>
          </ResponsiveContainer>
        )}
    </div>
  );
};

export default ReferralTrends;
